// Dumb card — no store, no SQL. A TotalCard with a sparkline behind the number, the sparkline's
// x-axis labels and a week-on-week percentage chip. Upstreamed from issue-analysis's
// components/cards/TotalSparkCard.vue (IA_ABSORPTION_PLAN Phase 4 step 13): props and template as
// they were, except that the x-axis labels now render (the old `v-if` sat on the `v-for` element,
// so `label` was undefined and no label ever showed); colours from @rdrive/theme
// (`chart.sparkline`), the counter from ../../composables/useAnimatedCount.js.
import setup from './setup.js';

export default {
  name: 'total-spark-card',
  props: {
    label: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    tooltip: {
      type: String,
      required: false
    },
    // Sparkline properties
    showSparkline: {
      type: Boolean,
      default: false
    },
    sparklineData: {
      type: Array,
      default: () => []
    },
    sparklineColor: {
      type: String,
      default: 'primary'
    },
    sparklineGradient: {
      type: Array,
      default: null
    },
    sparklineHeight: {
      type: Number,
      default: 50
    },
    sparklineLineWidth: {
      type: Number,
      default: 2
    },
    sparklineMin: {
      type: Number,
      default: 0
    },
    sparklineSmooth: {
      type: Boolean,
      default: true
    },
    sparklineLabels: {
      type: Array,
      default: () => []
    },
    // Percentage change properties
    showPercentageChange: {
      type: Boolean,
      default: false
    },
    percentageChange: {
      type: Number,
      default: null
    }
  },
  setup,
};
